(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/components/draw-selector-item.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/components/draw-selector-item.js');

'use strict';

const {
  Currency
} = svs.utils.format;
const {
  ShortDateAndTime
} = svs.utils.date;
const {
  formfactor
} = svs.core.detect;
function DrawSelectorItem(_ref) {
  let {
    partOfList,
    draw,
    onHandleClick,
    isSelected
  } = _ref;
  const extraMoneyTitle = formfactor.mobile() ? 'Extra: ' : 'Extrapengar: ',
    revenueTitle = formfactor.mobile() ? 'Oms.' : 'Omsättning:';
  let headClass = partOfList ? 'list-group-item draw-selector ' : '',
    handleClick = () => {},
    extraText = '';
  if (isSelected) {
    headClass += 'drawselector-current-round';
  } else {
    handleClick = () => onHandleClick(draw.drawNumber);
  }
  if (draw.fund !== null) {
    if (draw.fund.extraMoney !== '0,00') {
      extraText = "".concat(extraMoneyTitle + Currency(draw.fund.extraMoney), " kr");
    } else if (draw.fund.rolloverIn !== '0,00') {
      extraText = "Rullpott: ".concat(Currency(draw.fund.rolloverIn), " kr");
    }
  }
  return React.createElement("li", {
    className: headClass,
    onClick: handleClick
  }, React.createElement("div", {
    className: "horizontal-portion"
  }, React.createElement("div", {
    className: "half-portion draw-selector-description overflow-threedots"
  }, draw.drawComment), React.createElement("div", {
    className: "half-portion"
  }, extraText)), React.createElement("div", {
    className: "horizontal-portion"
  }, React.createElement("div", {
    className: "half-portion"
  }, "Spelstopp:", ' ', ShortDateAndTime(draw.regCloseTime, false).replace(', kl.', '')), React.createElement("div", {
    className: "half-portion"
  }, revenueTitle, " ", Currency(draw.currentNetSale), " kr")));
}
DrawSelectorItem.defaultProps = {
  isSelected: false,
  onHandleClick: () => {},
  partOfList: true
};
setGlobal('svs.sport.drawSelectorAssets.DrawSelectorItem', DrawSelectorItem);

 })(window);